import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { EppColorPickerComponent } from './epp-color-picker.component';


@NgModule({
  declarations: [EppColorPickerComponent],
  imports: [
    CommonModule,
    NzDropDownModule
  ],
  exports: [
    EppColorPickerComponent
  ]
})
export class EppColorPickerModule { }
